import { ref, onMounted, onUnmounted } from "vue";

export function usePopover(defaultOffset = 0, triggerCallback = null) {
    const isOpen = ref(false);
    const anchor = ref(null);
    const position = ref({ top: 0, left: defaultOffset });
    const currentOffset = ref(defaultOffset);

    const updatePosition = () => {
        if (!isOpen.value || !anchor.value) return;

        const rect = anchor.value.getBoundingClientRect();

        position.value = {
            top: triggerCallback === 'profile-area-trigger' ? rect.top-105 : rect.top,
            left: currentOffset.value,
        };
    };

    const openPopover = (event, dynamicOffset = null) => {
        anchor.value = event.currentTarget;
        
        if (dynamicOffset !== null) {
            currentOffset.value = dynamicOffset;
        } else {
            currentOffset.value = defaultOffset;
        }

        isOpen.value = true;
        updatePosition();
    };

    const closePopover = () => {
        isOpen.value = false;
        anchor.value = null;
    };

    onMounted(() => {
        window.addEventListener("scroll", updatePosition, true);
        window.addEventListener("resize", updatePosition);
    });

    onUnmounted(() => {
        window.removeEventListener("scroll", updatePosition, true);
        window.removeEventListener("resize", updatePosition);
    });

    return {
        isOpen,
        anchor,
        position,
        openPopover,
        closePopover,
        updatePosition,
    };
}